var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThegraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 469,
    viewBox: "0 0 364 469",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#32343F;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-109.6,-122.6)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 169.57,
    x2: 357.74,
    y1: 550.16,
    y2: 317.53,
    gradientTransform: "matrix(1,0,0,-1,0,710)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1E6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B4DD4",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m266.2 435.3c-21.1 0-41.5-4.1-60.7-12.3-18.6-7.9-35.3-19.1-49.6-33.4s-25.6-31-33.4-49.6c-8.1-19.3-12.3-39.7-12.3-60.7s4.1-41.5 12.3-60.7c7.9-18.6 19.1-35.3 33.4-49.6s31-25.6 49.6-33.4c19.3-8.1 39.7-12.3 60.7-12.3s41.5 4.1 60.7 12.3c18.6 7.9 35.3 19.1 49.6 33.4s25.6 31 33.4 49.6c8.1 19.3 12.3 39.7 12.3 60.7s-4.1 41.5-12.3 60.7c-7.9 18.6-19.1 35.3-33.4 49.6s-31 25.6-49.6 33.4c-19.2 8.1-39.6 12.3-60.7 12.3zm0-261.6c-58.2 0-105.5 47.3-105.5 105.5s47.4 105.6 105.6 105.6 105.6-47.4 105.6-105.6c-0.1-58.2-47.5-105.5-105.7-105.5z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 343.71,
    x2: 531.88,
    y1: 691.02,
    y2: 458.4,
    gradientTransform: "matrix(1,0,0,-1,0,710)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1E6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B4DD4",
    offset: 1
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 448.4,
    cy: 148.4,
    r: 24.6,
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    x1: 102.64,
    x2: 290.82,
    y1: 496.02,
    y2: 263.4,
    gradientTransform: "matrix(1,0,0,-1,0,710)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1E6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B4DD4",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m292.1 590.9c-6.5 0-12.9-2.5-17.8-7.4-9.9-9.9-9.9-25.8 0-35.7l105-105c9.9-9.9 25.8-9.9 35.7 0s9.9 25.8 0 35.7l-105 105c-5 5-11.5 7.4-17.9 7.4z",
    fill: "url(#SVGID_3_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThegraph);
export default __webpack_public_path__ + "static/media/thegraph.2b0565c93ca7d115885098e8584b31d5.svg";
export { ForwardRef as ReactComponent };